import { render } from "./Logo.vue?vue&type=template&id=23c40b62&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=23c40b62&scoped=true&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c40b62"]])

export default __exports__